import { render, staticRenderFns } from "./OrderPaymentFailed.vue?vue&type=template&id=13677a76&lang=html"
import script from "./OrderPaymentFailed.vue?vue&type=script&lang=js"
export * from "./OrderPaymentFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports